const KEY_CODES = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  DELETE: 46,
  ESCAPE: 27,
  RETURN: 13,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
});

export default KEY_CODES;
